<!-- role="alert" so the failure is announced: someone using a screen reader
     otherwise gets no signal that the submit went nowhere. -->
<div
  class="auth-error-banner"
  *ngIf="messages.length"
  role="alert"
  data-testid="login-error-banner"
>
  <p class="auth-error-banner__message" *ngFor="let message of messages">
    {{ message }}
  </p>
</div>
